import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { beautyBaseUrl } from "network";

export const subscriptionSlice = createApi({
    reducerPath: "subscriptionSlice",
    baseQuery: fetchBaseQuery({
        baseUrl: beautyBaseUrl,
        credentials: "include",
        prepareHeaders: (headers, { getState }) => {
            const state = getState();
            const token = state.auth?.token;
            if (token) {
                console.log('token', token);
                headers.set("authorization", `Bearer ${token}`);
            } else {
                console.warn("Token not found in state.auth");
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        // ✅ Get All Categories
        getSubscriptions: builder.query({
            query: ({ page = 1, limit = 100, search = "" }) => ({
                url: `/subscription?page=${page}&limit=${limit}&search=${search}`,
                method: "GET",
            }),
            transformResponse: (response) => response,
        }),

        // ✅ Add New Category
        addSubscription: builder.mutation({
            query: (body) => ({
                url: "/subscription",
                method: "POST",
                body,
            }),
        }),

        // ✅ Update Existing Category
        updateSubscription: builder.mutation({
            query: ({ id, body }) => ({
                url: `/subscription/${id}`,
                method: "PUT",
                body,
            }),
        }),

        // ✅ Delete Category
        deleteSubscription: builder.mutation({
            query: (id) => ({
                url: `/subscription/${id}`,
                method: "DELETE",
            }),
        }),

        // ✅ Get single subscription by ID
        getSingleSubscription: builder.query({
            query: (id) => ({
                url: `/subscription/${id}`,
                method: "GET",
            }),
        }),
    }),
});

export const {
    useGetSubscriptionsQuery,
    useAddSubscriptionMutation,
    useUpdateSubscriptionMutation,
    useDeleteSubscriptionMutation,
    useGetSingleSubscriptionQuery,
} = subscriptionSlice;
